/**
 * Slime Junkies — Theme JavaScript
 * 90s Nickelodeon Retro Theme
 */

(function () {
  'use strict';

  /* ================================================
     MOBILE MENU
     ================================================ */
  const MobileMenu = {
    init() {
      this.menu = document.querySelector('.mobile-menu');
      this.openBtn = document.querySelector('.mobile-menu-toggle');
      this.closeBtn = document.querySelector('.mobile-menu__close');

      if (!this.menu) return;

      this.openBtn?.addEventListener('click', () => this.open());
      this.closeBtn?.addEventListener('click', () => this.close());

      this.menu.addEventListener('click', (e) => {
        if (e.target.classList.contains('mobile-menu__link')) this.close();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) this.close();
      });
    },

    open() {
      this.menu.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    },

    close() {
      this.menu.classList.remove('is-active');
      document.body.style.overflow = '';
    },

    isOpen() {
      return this.menu.classList.contains('is-active');
    }
  };

  /* ================================================
     CART DRAWER
     ================================================ */
  const CartDrawer = {
    init() {
      this.drawer = document.querySelector('.cart-drawer');
      this.overlay = document.querySelector('.cart-drawer__overlay');
      this.closeBtn = document.querySelector('.cart-drawer__close');

      if (!this.drawer) return;

      document.querySelectorAll('[data-cart-toggle]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });

      this.closeBtn?.addEventListener('click', () => this.close());
      this.overlay?.addEventListener('click', () => this.close());

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) this.close();
      });
    },

    open() {
      this.drawer.classList.add('is-active');
      this.overlay?.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    },

    close() {
      this.drawer.classList.remove('is-active');
      this.overlay?.classList.remove('is-active');
      document.body.style.overflow = '';
    },

    isOpen() {
      return this.drawer.classList.contains('is-active');
    },

    async refresh() {
      try {
        const res = await fetch('/?sections=cart-drawer');
        const data = await res.json();
        const html = data['cart-drawer'];

        if (html) {
          const temp = document.createElement('div');
          temp.innerHTML = html;

          const newItems = temp.querySelector('.cart-drawer__items');
          const newFooter = temp.querySelector('.cart-drawer__footer');
          const currentItems = this.drawer.querySelector('.cart-drawer__items');
          const currentFooter = this.drawer.querySelector('.cart-drawer__footer');

          if (newItems && currentItems) currentItems.innerHTML = newItems.innerHTML;
          if (newFooter && currentFooter) currentFooter.innerHTML = newFooter.innerHTML;
        }

        this.updateCartCount();
      } catch (err) {
        console.error('Cart drawer refresh failed:', err);
      }
    },

    async updateCartCount() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        document.querySelectorAll('.site-header__cart-count').forEach((el) => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      } catch (err) {
        console.error('Cart count update failed:', err);
      }
    }
  };

  /* ================================================
     PRODUCT IMAGE GALLERY
     ================================================ */
  const ProductGallery = {
    init() {
      this.mainImage = document.getElementById('ProductMainImg');
      this.thumbnails = document.getElementById('ProductThumbnails');

      if (!this.mainImage || !this.thumbnails) return;

      this.thumbnails.addEventListener('click', (e) => {
        const thumb = e.target.closest('.product-page__thumbnail');
        if (!thumb) return;

        const url = thumb.dataset.imageUrl;
        const alt = thumb.dataset.imageAlt;

        if (url) {
          this.mainImage.src = url;
          this.mainImage.alt = alt || '';

          this.thumbnails.querySelectorAll('.product-page__thumbnail').forEach((t) => {
            t.classList.remove('is-active');
          });
          thumb.classList.add('is-active');
        }
      });
    }
  };

  /* ================================================
     QUANTITY SELECTORS
     ================================================ */
  const QuantitySelectors = {
    init() {
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('.quantity-selector__btn');
        if (!btn) return;

        const action = btn.dataset.action;
        const controls = btn.closest('.quantity-selector__controls');
        const input = controls?.querySelector('.quantity-selector__input');
        if (!input) return;

        let value = parseInt(input.value, 10) || 1;
        const min = parseInt(input.min, 10) || 0;

        if (action === 'increase') {
          value++;
        } else if (action === 'decrease' && value > min) {
          value--;
        }

        input.value = value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  };

  /* ================================================
     AJAX ADD TO CART
     ================================================ */
  const AjaxCart = {
    init() {
      const form = document.querySelector('[data-product-form]');
      if (!form) return;

      form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const submitBtn = form.querySelector('[type="submit"]');
        const originalText = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';

        try {
          const formData = new FormData(form);

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });

          if (!res.ok) {
            const error = await res.json();
            throw new Error(error.description || 'Could not add to cart');
          }

          await CartDrawer.refresh();
          CartDrawer.open();

          submitBtn.textContent = 'Added!';
          setTimeout(() => {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 1500);
        } catch (err) {
          console.error('Add to cart error:', err);
          submitBtn.textContent = err.message || 'Error';
          setTimeout(() => {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 2000);
        }
      });
    }
  };

  /* ================================================
     PRODUCT VARIANT SELECTOR
     ================================================ */
  const VariantSelector = {
    init() {
      this.productJSON = document.getElementById('ProductJSON');
      if (!this.productJSON) return;

      try {
        this.product = JSON.parse(this.productJSON.textContent);
      } catch {
        return;
      }

      this.options = [];
      this.product.options.forEach((_, i) => {
        const container = document.getElementById(`Option-${i + 1}`);
        if (container) {
          const selected = container.querySelector('.variant-option.is-selected');
          this.options[i] = selected ? selected.dataset.value : '';
        }
      });

      document.addEventListener('click', (e) => {
        const optionBtn = e.target.closest('.variant-option');
        if (!optionBtn) return;

        const index = parseInt(optionBtn.dataset.optionIndex, 10);
        const value = optionBtn.dataset.value;

        const container = optionBtn.closest('.variant-selector__options');
        container.querySelectorAll('.variant-option').forEach((b) => b.classList.remove('is-selected'));
        optionBtn.classList.add('is-selected');

        this.options[index] = value;
        this.updateVariant();
      });
    },

    updateVariant() {
      const selectedVariant = this.product.variants.find((variant) => {
        return variant.options.every((opt, i) => opt === this.options[i]);
      });

      if (!selectedVariant) return;

      const variantIdInput = document.getElementById('ProductVariantId');
      if (variantIdInput) variantIdInput.value = selectedVariant.id;

      const priceContainer = document.getElementById('ProductPrice');
      if (priceContainer) {
        const currentPrice = priceContainer.querySelector('.product-page__price--current');
        const comparePrice = priceContainer.querySelector('.product-page__price--compare');

        if (currentPrice) {
          currentPrice.textContent = this.formatMoney(selectedVariant.price);
        }
        if (comparePrice) {
          if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
            comparePrice.textContent = this.formatMoney(selectedVariant.compare_at_price);
            comparePrice.style.display = '';
          } else {
            comparePrice.style.display = 'none';
          }
        }
      }

      const addBtn = document.getElementById('AddToCart');
      if (addBtn) {
        if (selectedVariant.available) {
          addBtn.disabled = false;
          addBtn.textContent = window.slimeStrings?.addToCart || 'Slime It!';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = window.slimeStrings?.soldOut || 'Sold Out';
        }
      }

      if (selectedVariant.featured_image) {
        const mainImg = document.getElementById('ProductMainImg');
        if (mainImg) {
          mainImg.src = selectedVariant.featured_image.src;
          mainImg.alt = selectedVariant.featured_image.alt || '';
        }
      }

      const url = new URL(window.location);
      url.searchParams.set('variant', selectedVariant.id);
      window.history.replaceState({}, '', url.toString());
    },

    formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  /* ================================================
     SMOOTH SCROLL FOR ANCHOR LINKS
     ================================================ */
  const SmoothScroll = {
    init() {
      document.addEventListener('click', (e) => {
        const link = e.target.closest('a[href^="#"]');
        if (!link) return;

        const targetId = link.getAttribute('href');
        if (targetId === '#' || targetId.length < 2) return;

        const target = document.querySelector(targetId);
        if (!target) return;

        e.preventDefault();
        const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 80;

        window.scrollTo({
          top: target.offsetTop - headerHeight - 20,
          behavior: 'smooth'
        });
      });
    }
  };

  /* ================================================
     ANIMATE ON SCROLL (Intersection Observer)
     ================================================ */
  const AnimateOnScroll = {
    init() {
      const elements = document.querySelectorAll('.animate-in');
      if (!elements.length) return;

      elements.forEach((el) => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(30px)';
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.style.opacity = '';
              entry.target.style.transform = '';
              entry.target.classList.add('animate-in--visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
      );

      elements.forEach((el) => observer.observe(el));
    }
  };

  /* ================================================
     COLLECTION SORT
     ================================================ */
  const CollectionSort = {
    init() {
      const sortSelect = document.querySelector('[data-sort-select]');
      if (!sortSelect) return;

      sortSelect.addEventListener('change', () => {
        const url = new URL(window.location);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location = url.toString();
      });
    }
  };

  /* ================================================
     INIT ALL MODULES
     ================================================ */
  document.addEventListener('DOMContentLoaded', () => {
    MobileMenu.init();
    CartDrawer.init();
    ProductGallery.init();
    QuantitySelectors.init();
    AjaxCart.init();
    VariantSelector.init();
    SmoothScroll.init();
    AnimateOnScroll.init();
    CollectionSort.init();
  });
})();
